import React, { useContext } from 'react';
import { CommandBarButton, Stack, StackItem, Toggle } from '@fluentui/react';
import { AppThemeContext } from '../contexts/AppThemeContext';
import { withRouter } from 'react-router-dom';
import { AppAuthContext } from '../contexts/AppAuthContext';

const NavBar = (props) => {
    const { theme, isDark, setDarkTheme } = useContext(AppThemeContext);
    const { isAuth, SignOut } = useContext(AppAuthContext);

    const myStyles = {
        navbar: {
            root: {
                zIndex: 1000,
                height: '3rem',
                boxShadow: theme.effects.elevation8,
            }
        },
        logoButton: {
            root: {
            },
            label: {
                color: theme.palette.themePrimary,
                margin: 0,
                alignSelf: 'center',
                paddingLeft: theme.spacing.s1,
                marginRight: theme.spacing.s1,
                ...theme.fonts.xLarge
            }
        },
        darkThemeToggle: {
            root: {
                alignSelf: 'center',
                marginTop: theme.spacing.m,
                marginRight: theme.spacing.m,
            },
        },
        userProfileButton: {
            root: {
                marginRight: theme.spacing.m,
            }
        }
    };

    const userProfileMenuProps = {
        items: [
            {
                key: 'profile',
                text: 'پروفایل',
                iconProps: { iconName: 'Contact' }
            },
            {
                key: 'signout',
                text: 'خروج',
                iconProps: { iconName: 'PowerButton' },
                onClick: SignOut
            }
        ],
        // directionalHintFixed: true
    };

    const btnHome_Click = () => {
        if (props.history.location.pathname.toLowerCase() !== "/")
            props.history.push("/");
    }

    const handleSignInClick = () => {
        if (props.history.location.pathname.toLowerCase() !== "/signin")
            props.history.push("/signin");
    }

    return (
        <Stack horizontal styles={myStyles.navbar}>
            <StackItem grow>
                <Stack horizontal verticalFill verticalAlign='stretch'>
                    <CommandBarButton
                        text="پرتال کاوش"
                        onClick={btnHome_Click}
                        styles={myStyles.logoButton}
                    />
                </Stack>
            </StackItem>
            <StackItem verticalFill>
                <Stack horizontal verticalFill verticalAlign='stretch'>
                    <Toggle styles={myStyles.darkThemeToggle} defaultChecked={isDark} onChange={(ev, checked) => setDarkTheme(checked)} />
                    {isAuth ?
                        <CommandBarButton
                            styles={myStyles.userProfileButton}
                            iconProps={{ iconName: 'Contact' }}
                            title={"پروفایل"}
                            menuProps={userProfileMenuProps}
                        />
                        :
                        <CommandBarButton
                            styles={myStyles.userProfileButton}
                            iconProps={{ iconName: 'SignIn' }}
                            title="ورود"
                            onClick={handleSignInClick}
                        />
                    }
                </Stack>
            </StackItem>
        </Stack>
    )

}

export default withRouter(NavBar);